import { useState } from "react";
import "./changeMeasurementSystemAlertMessage.css";

export const ChangeMeasurementSystemAlertMessage = ({ onClose,
    continueSelection,
    warningDesc }) => {
    const [warningDescription, setWarningDescription] = useState(warningDesc ? warningDesc :
        "You are about to change the measurement system (metric or imperial). This action will affect the selection of measurement units for the shelves and bins associated with this location.  Do you wish to proceed with the change?"
    );

    const handleContinue = () => {
        continueSelection();
        onClose();
    }
    return (
        <div className="change-systemMeasure-modal-cont">
            <section className="change-systemMeasure-modal-cont-header">
                <button><i className="icon-warning"></i></button>
                <p>Alert Message</p>
            </section>
            <div className="change-systemMeasure-modal-cont">
                {warningDescription}
            </div>
            <div className="btn-changeSystemCont">
                <button onClick={handleContinue}>
                    Ok
                </button>
                <button onClick={onClose}>
                    Cancel
                </button>
            </div>
        </div>
    );
};